export default { sha: '33669331b7eaf811821f1ff9d31acaa97ea858f7', buildNumber: 'undefined' }
